import { render, staticRenderFns } from "./AssumptionsBreadcrumb.vue?vue&type=template&id=0d2068f4&scoped=true&"
import script from "./AssumptionsBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./AssumptionsBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./AssumptionsBreadcrumb.vue?vue&type=style&index=0&id=0d2068f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2068f4",
  null
  
)

export default component.exports